import { useMemo } from "react";

import type * as Repository from "../../../_repository";
import type * as Type from "../type";

type QueryData = Repository.Query.QueryData.OptionPmsList.OptionPmsActiveListQueryData;
type Props = {
	optionPmsActiveListQueryData: QueryData;
	viewData: Type.ViewData;
};
type Result = {
	filteredOptionPmsActiveListQueryData: QueryData;
};

export const useFilterOptionPmsActiveListQueryDataBySearchParams = ({
	optionPmsActiveListQueryData,
	viewData,
}: Props): Result => {
	/**
	 * 絞り込み条件を軸にオプションリストを絞り込む
	 */
	const filteredOptionPmsActiveListQueryData = useMemo((): QueryData => {
		/**
		 * 全てのオプションを表示する場合はそのまま返す
		 */
		if (viewData.displayAll) return optionPmsActiveListQueryData;

		const {
			optionPmsList: { id, options: optionsQueryData },
		} = optionPmsActiveListQueryData;
		/**
		 * 選択中のオプションのみに絞り込む
		 */
		const onlyCheckedOptionsViewData = viewData.options.filter(({ checked }) => checked);
		/**
		 * 表示対象のオプションのみを表示
		 */
		const options = optionsQueryData.filter(({ optionID }) =>
			onlyCheckedOptionsViewData.some(({ id }) => id === optionID),
		);
		return {
			...optionPmsActiveListQueryData,
			optionPmsList: {
				id,
				options,
			},
		} satisfies QueryData;
	}, [optionPmsActiveListQueryData, viewData.displayAll, viewData.options]);

	return {
		filteredOptionPmsActiveListQueryData,
	};
};
